import {Alert, Button} from '@mui/material';
import {MdOutlineTipsAndUpdates} from 'react-icons/md';
import {useOffice} from '../../../../contexts/office/context';
import {useHistory, useLocation, useRouteMatch} from 'react-router-dom';
import {ScreenPaths} from '../../../../enums';
import {useAuth} from '../../../../contexts/auth/context';
import {translations} from '../../../../i18n/translations';
import {Trans, useTranslation} from 'react-i18next';
import {IoMdClose} from 'react-icons/io';

export function PendingAlert() {
  const location = useLocation();
  let history = useHistory();
  const {
    state: {pendingTasksVisible},
    showPendingTasks,
  } = useOffice();
  const {state: authState} = useAuth();
  const {t} = useTranslation();
  let {path} = useRouteMatch();

  if (
    !pendingTasksVisible ||
    location.pathname.includes(ScreenPaths.Entity_Planner_PendingTasks) ||
    location.pathname.includes(ScreenPaths.Me_Notifications)
  ) {
    return null;
  }

  return (
    <Alert
      className="pending-tasks-alert"
      severity="success"
      variant="outlined"
      icon={<MdOutlineTipsAndUpdates />}
      action={
        <>
          <Button
            onClick={() =>
              history.push(
                `${path}${ScreenPaths.Office_ProfessionalCaregiver}/${authState.session?.selectedAffiliation?.entity.id}${ScreenPaths.Entity_Planner_PendingTasks}`,
                {from: location.pathname}
              )
            }
            className="see"
            variant="contained"
            color="primary"
          >
            {t(translations.office.pending_tasks.see_tasks)}
          </Button>
          <Button onClick={() => showPendingTasks(false)} className="close" variant="text">
            <IoMdClose />
          </Button>
        </>
      }
    >
      <Trans values={{number: ''}}>{t(translations.office.pending_tasks.alert)}</Trans>
    </Alert>
  );
}
